import { FeaturePost } from '../FeaturePosts';

export const moodTracker: FeaturePost = {
  id: 'mood-tracker',
  cardImage: `${process.env.PUBLIC_URL}/assets/features/mood.png`,
  image: '',
  tag: 'Tracking',
  date: '2026-06-02',
  title: 'Mood Tracker',
  subtitle: 'Track how you feel alongside your symptoms',
  readTime: '2 min',
  content: `Chronic illness affects more than just your body. The mood tracker lets you log how you're feeling emotionally, right next to your symptoms, food and medications.

#### Highlights

- Choose from a range of moods, each with its own little Toastie expression
- See mood insights over time
- Spot how your mood and symptoms relate to each other`,
};
